// export const API_URL = "http://localhost:3011";
// export const API_URL_UPLOADS = "http://192.225.73.7:3020";
export const API_URL_STORE = "https://srv547457.hstgr.cloud:3009";
export const API_URL = 'https://srv547457.hstgr.cloud:3011';
// export const API_URL_STORE = "https://srv547457.hstgr.cloud:3009";
export const API_URL_UPLOADS = "https://srv547457.hstgr.cloud:3020";